/**
 * Check if the current session is a demo session by looking for demo_session cookie
 */
export function isDemoSession(): boolean {
  if (typeof window === 'undefined') return false

  return document.cookie
    .split(';')
    .some((cookie) => cookie.trim().startsWith('demo_session=true'))
}
